import { CTA, styled } from '@vw-marketing/us-components';
import { VWTheme } from '../../../../shared/typings/vw-theme';

export const StyledManageContactsAlertsTitle = styled.div`
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    gap: ${( props ) =>  props.theme.size.static200 };
`;

export const StyledManageContactsAlertsContent = styled.div`
    display: flex;
    flex-direction: column;
    gap: ${( props ) =>  props.theme.size.static100 };
    
`;

export const StyledManageContactsAlerts = styled.div`
    display: flex;
    flex-direction: column;
    gap: ${( props ) =>  props.theme.size.static150 };
    width: 100%;
`;

export const StyledManageContactsAlertsPrimary = styled.div`
    display: flex;
    flex-direction: column;
    padding: ${( props ) =>  props.theme.size.static200 } 0;
    width: 100%;
    overflow: hidden;

    div {
        overflow: hidden;
        text-overflow: ellipsis; 
    } 
`;

export const StyledManageContactsAlertsAdditional = styled.div`
    display: flex;
    flex-direction: column;
    gap: ${( props ) =>  props.theme.size.static250 };
    padding: ${( props ) =>  props.theme.size.static200 } 0;
    width: 100%;
    justify-content: space-between;
    align-items: flex-start;

    @media (min-width: 370px) {
        flex-direction: row;
        align-items: center;
        
    }
`;

export const StyledManageContactsAlertsAdditionalContent = styled.div`
    display: flex;
    flex-direction: column;
    width: 100%;
    overflow: hidden;

    div {
        overflow: hidden;
        text-overflow: ellipsis; 
    } 
`;

export const StyledManageContactsAlertsAdditionalCTA = styled.div`
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-self: stretch;
    gap: ${( props ) =>  props.theme.size.static250 };

    @media (min-width: 370px) {
        justify-content: flex-end;
        align-items: center;
        gap: ${( props ) =>  props.theme.size.static300 };
        align-self: auto;
    }
`;

export const StyledManageContactsAlertsAdditionalCTARemove = styled(CTA)<{ customProperties?: boolean }>`
    ${({ theme }: { theme: VWTheme }) => {
    return `
      color: ${theme.colors.signal.error};
      border: 1px solid ${theme.colors.signal.error};
    `;
  }}

    ${({ customProperties }) => !customProperties && `
        padding: 4px 4px;

        div {
            column-gap: 0px;
        }
    `}
`;

export const StyledManageContactsAlertsAdditionalCTAEdit = styled(CTA)<{ customProperties?: boolean }>`
    ${({ customProperties }) => !customProperties && `
        padding: 4px 4px;

        div {
            column-gap: 0px;
        }
    `}
`;